import React from 'react'
import Badge from '@cloudscape-design/components-themed/badge'
import { RadBox } from './RadBox'

// https://cloudscape.design/components/badge
export function RadBadge ({ key, featured = false, collection = false, className, ...rest }) {
  const badgeClass = featured
    ? `featured-badge ${className || ''}`.trim()
    : collection
      ? `collection-badge ${className || ''}`.trim()
      : className

  return (
    <Badge color={featured || collection ? 'green' : 'blue'} key={key} className={badgeClass}>
      <RadBox variant='small' color='text-label' key={key} {...rest} />
    </Badge>
  )
}
